import React, { useState } from "react";
import { Button, Row, Col } from "react-bootstrap";
import Icon from './Icon';
import { Link } from 'react-router-dom';
import CardsManagers from './CardsManagers';
import CardsAssistant from './CardsAssistant';
import CardsPods from '../components/CardsPods'

const ManagerCard = ({ data, heading, initialSection = 'managers', onTabChange }) => {
  const [activeSection, setActiveSection] = useState(initialSection);

  const managersCount = data?.managers ? String(data.managers.length).padStart(2,'0') : '0';
  const assistantsCount = data?.assistants ? String(data.assistants.length).padStart(2,'0') : '0';
  const podsCount = data?.pods? String(data.pods.length).padStart(2,'0') : '0';
  return ( 
    <div className="p-24 rounded-16 app-shadow-sm bg-white mb-24">
      <div className="d-flex align-items-center mb-12 branch-card-header">
        <span className="mask-icon w-h-16 mask-branches" aria-hidden="true"></span>
        <div className="fw-600 text-16 text-black ">{heading}</div>
      </div>
      {/* Tabs */}
      <div className="d-flex align-items-center gap-12 mb-16 flex-wrap">
        <button
          className={`chip-tab ${activeSection === 'managers' ? 'active' : ''}`}
          onClick={() => {
            setActiveSection('managers');
            onTabChange && onTabChange('managers');
          }}
        >
          <span className="mask-icon w-h-14 mask-managers" aria-hidden="true"></span>
          <span className="text-12 fw-600">Managers: {managersCount}</span>
        </button>
        <button
          className={`chip-tab ${activeSection === 'assistants' ? 'active' : ''}`}
          onClick={() => {
            setActiveSection('assistants');
            onTabChange && onTabChange('assistants');
          }}
        >
          <span className="mask-icon w-h-14 mask-assistants" aria-hidden="true"></span>
          <span className="text-12 fw-600">Assistant: {assistantsCount}</span>
        </button>
        <button
          className={`chip-tab ${activeSection === 'pods' ? 'active' : ''}`}
          onClick={() => {
            setActiveSection('pods');
            onTabChange && onTabChange('pods');
          }}
        >
          <span className="mask-icon w-h-14 mask-teams" aria-hidden="true"></span>
          <span className="text-12 fw-600">Pods/Teams: {podsCount}</span>
        </button>
      </div>
      {activeSection === 'managers' && (
      <div className="mb-16">
        {data.managers != undefined && data.managers.length > 0 ? (
          <Row>
            {data.managers.map((item, index) => (
              <Col key={index} sm={12} md={6} className='mb-16'>
                <CardsManagers
                  CardLabel={item.name}
                  phone={item.phone}
                  email={item.email}
                  PageRoute={`/manager/singlemanager/${item.id}`}
                />
              </Col>
            ))}
          </Row>
        ) : (
          <div className="mb-10 text-10 fw-400 text-767676">Managers not found</div>
        )}
      </div>
      )}
      {activeSection === 'assistants' && (
      <div className="mb-16">
        {data.assistants != undefined && data.assistants.length > 0 ? (
          <Row>
            {data.assistants.map((item, index) => (
              <Col key={index} sm={12} md={6} className='mb-16'>
                <CardsAssistant
                  CardLabel={item.name}
                  phone={item.phone}
                  email={item.email}
                  PageRoute={`/assistants/singleassistant/${item.id}`}
                  CardColor='bg-brand-light'
                />
              </Col>
            ))}
          </Row>
        ) : (
          <div className="mb-10 text-10 fw-400 text-767676">Assistants not found</div>
        )}
      </div>
      )}
      {activeSection === 'pods' && (
      <div className="mb-16">
        <div className="d-flex align-items-center gap-3 flex-wrap">
          {/* Items Under Section */}
          {
            data.pods != undefined && data.pods.length > 0 ?
              data.pods.map((item, itemIndex) => (
                <CardsPods
                    CardColor="bg-brand-light"
                    CardLabel={item.name}
                    teamLeadName={undefined}
                    membersCount={undefined}
                    PageRoute={"/teams_pods/singlepods/" + item.id}
                />
              ))
              : <div className="mb-10 text-10 fw-400 text-767676">PODS not found</div>
          }
        </div>
      </div>
      )}
    </div>
  );
};

export default ManagerCard;
